(function () {
  "use strict";

  /* =========================================================
     VIBES CART
     Shopify AJAX cart controller
  ========================================================= */

  var FREE_SHIPPING_THRESHOLD = 5000; // $50
  var MAX_QTY = 99;

  var cart = null;
  var busy = false;

  function getRoot() {
    return document.getElementById("vibes-cart-drawer");
  }

  function getPanel() {
    var root = getRoot();
    return root ? root.querySelector("[data-vibes-cart-panel]") : null;
  }

  function getOverlay() {
    var root = getRoot();
    return root ? root.querySelector("[data-vibes-cart-overlay]") : null;
  }

  function money(cents) {
    var amount = Number(cents || 0) / 100;

    if (Number.isInteger(amount)) {
      return "$" + amount.toFixed(0);
    }

    return "$" + amount.toFixed(2);
  }

  function escapeHTML(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) {
        throw new Error("Cart request failed: " + response.status);
      }

      return response.json();
    });
  }

  /* =========================================================
     OPEN / CLOSE
  ========================================================= */

  function openCart() {
    var root = getRoot();
    var panel = getPanel();
    var overlay = getOverlay();

    if (!root || !panel) return;

    root.classList.remove("pointer-events-none");
    root.setAttribute("aria-hidden", "false");

    root.style.pointerEvents = "auto";

    panel.style.transform = "translateX(0)";
    panel.style.pointerEvents = "auto";

    if (overlay) {
      overlay.style.opacity = "1";
      overlay.style.pointerEvents = "auto";
    }

    document.documentElement.style.overflow = "hidden";
  }

  function closeCart() {
    var root = getRoot();
    var panel = getPanel();
    var overlay = getOverlay();

    if (!root || !panel) return;

    panel.style.transform = "translateX(100%)";

    if (overlay) {
      overlay.style.opacity = "0";
      overlay.style.pointerEvents = "none";
    }

    root.setAttribute("aria-hidden", "true");

    window.setTimeout(function () {
      root.classList.add("pointer-events-none");
      root.style.pointerEvents = "none";
    }, 300);

    document.documentElement.style.overflow = "";
  }

  /* =========================================================
     CART ITEM HTML
  ========================================================= */

  function lineItemHTML(item, lineNumber) {
    var title = item.product_title || item.title || "";
    var unitPrice =
      item.final_price != null ? item.final_price : item.price;

    var lineTotal =
      item.final_line_price != null
        ? item.final_line_price
        : unitPrice * item.quantity;

    var image = "";

    if (item.image) {
      image =
        '<img' +
        ' src="' +
        escapeHTML(item.image) +
        '"' +
        ' alt="' +
        escapeHTML(title) +
        '"' +
        ' class="vibes-cart-line__img"' +
        ' loading="lazy"' +
        ">";
    }

    return (
      '<li class="vibes-cart-line">' +
      '<div class="vibes-cart-line__media">' +
      image +
      "</div>" +
      '<div class="vibes-cart-line__content">' +
      '<div class="vibes-cart-line__top">' +
      '<div class="vibes-cart-line__info">' +
      '<p class="vibes-cart-line__title">' +
      escapeHTML(title) +
      "</p>" +
      '<p class="vibes-cart-line__unit-price">' +
      money(unitPrice) +
      "</p>" +
      "</div>" +
      '<p class="vibes-cart-line__total">' +
      money(lineTotal) +
      "</p>" +
      "</div>" +
      '<div class="vibes-cart-line__actions">' +
      '<div class="vibes-cart-line__qty">' +
      '<button type="button"' +
      ' data-vibes-line="' +
      lineNumber +
      '"' +
      ' data-vibes-action="dec"' +
      ' aria-label="Decrease quantity">−</button>' +
      "<span>" +
      item.quantity +
      "</span>" +
      '<button type="button"' +
      ' data-vibes-line="' +
      lineNumber +
      '"' +
      ' data-vibes-action="inc"' +
      ' aria-label="Increase quantity">+</button>' +
      "</div>" +
      '<button type="button"' +
      ' data-vibes-line="' +
      lineNumber +
      '"' +
      ' data-vibes-action="remove"' +
      ' class="vibes-cart-line__remove">Remove</button>' +
      "</div>" +
      "</div>" +
      "</li>"
    );
  }

  /* =========================================================
     RENDER
  ========================================================= */

  function renderCart() {
    var root = getRoot();

    if (!root || !cart) return;

    var linesEl = root.querySelector("#vibes-cart-lines");
    var emptyEl = root.querySelector("[data-vibes-cart-empty]");
    var footerEl = root.querySelector("[data-vibes-cart-footer]");
    var subtotalEl = root.querySelector("[data-vibes-cart-subtotal]");
    var shippingMessageEl = root.querySelector(
      "[data-vibes-shipping-message]"
    );
    var shippingBarEl = root.querySelector(
      "[data-vibes-shipping-bar]"
    );
    var shippingNoteEl = root.querySelector(
      "[data-vibes-shipping-note]"
    );

    var hasItems = !!(cart.items && cart.items.length);

    /* Header cart counts */
 document
  .querySelectorAll("[data-vibes-cart-count]")
  .forEach(function (badge) {
    var count = cart.item_count || 0;

    badge.textContent = String(count);
    badge.style.display = count > 0 ? "grid" : "none";
  });

    /* Empty state */
    if (emptyEl) {
      emptyEl.hidden = hasItems;
    }

    if (footerEl) {
      footerEl.hidden = !hasItems;
    }

    if (linesEl) {
      linesEl.hidden = !hasItems;

      if (hasItems) {
        var html = "";

        cart.items.forEach(function (item, index) {
          html += lineItemHTML(item, index + 1);
        });

        linesEl.innerHTML = html;
      } else {
        linesEl.innerHTML = "";
      }
    }

    /* Subtotal */
    var subtotal = cart.items_subtotal_price || 0;

    if (subtotalEl) {
      subtotalEl.textContent = money(subtotal);
    }

    /* Shipping progress */
    var remaining = Math.max(
      0,
      FREE_SHIPPING_THRESHOLD - subtotal
    );

    var progress = Math.min(
      1,
      subtotal / FREE_SHIPPING_THRESHOLD
    );

    if (shippingMessageEl) {
      if (remaining > 0) {
        shippingMessageEl.innerHTML =
          '<p>You&#39;re <span class="vibe-gradient-text font-bold">' +
          money(remaining) +
          "</span> away from free US shipping</p>";
      } else {
        shippingMessageEl.innerHTML =
          '<p class="font-bold">You&#39;ve unlocked free US shipping</p>';
      }
    }

    if (shippingBarEl) {
      shippingBarEl.style.width = progress * 100 + "%";
    }

    if (shippingNoteEl) {
      shippingNoteEl.textContent =
        remaining > 0
          ? "free over $50"
          : "free shipping applied";
    }
  }

  /* =========================================================
     SHOPIFY CART API
  ========================================================= */

  function refreshCart() {
    return fetchJSON("/cart.js").then(function (nextCart) {
      cart = nextCart;
      renderCart();
      return cart;
    });
  }

  function changeLine(lineNumber, quantity) {
    if (busy) return;

    busy = true;

    fetchJSON("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        line: lineNumber,
        quantity: quantity
      })
    })
      .then(function (nextCart) {
        cart = nextCart;
        renderCart();

        if (!cart.item_count) {
          // Keep drawer open so empty-state appears.
          openCart();
        }
      })
      .catch(function (error) {
        console.error("[vibes-cart] change failed", error);
      })
      .finally(function () {
        busy = false;
      });
  }

  function addToCart(variantId, quantity) {
    if (busy || !variantId) return;

    busy = true;

    fetchJSON("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: Number(quantity || 1)
          }
        ]
      })
    })
      .then(function () {
        return refreshCart();
      })
      .then(function () {
        openCart();
      })
      .catch(function (error) {
        console.error("[vibes-cart] add failed", error);
      })
      .finally(function () {
        busy = false;
      });
  }

  /* =========================================================
     ONE EVENT LISTENER FOR EVERYTHING
  ========================================================= */

  document.addEventListener("click", function (event) {
    var target = event.target;

    if (!(target instanceof Element)) return;

    /* Open cart */
    var openButton = target.closest("[data-vibes-cart-open]");

    if (openButton) {
      event.preventDefault();

      refreshCart().finally(function () {
        openCart();
      });

      return;
    }

    /* Add to cart */
    var addButton = target.closest("[data-vibes-add]");

    if (addButton) {
      event.preventDefault();

      var variantId = parseInt(
        addButton.getAttribute("data-vibes-add"),
        10
      );

      if (variantId) {
        addToCart(variantId, 1);
      }

      return;
    }

    var root = getRoot();

    if (!root || !root.contains(target)) return;

    /* Close buttons */
    var closeButton = target.closest(
      "[data-vibes-cart-close]"
    );

    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();
      closeCart();
      return;
    }

    /* Overlay */
    var overlay = target.closest(
      "[data-vibes-cart-overlay]"
    );

    if (overlay) {
      event.preventDefault();
      closeCart();
      return;
    }

    /* Quantity / remove */
    var actionButton = target.closest(
      "[data-vibes-action]"
    );

    if (actionButton) {
      event.preventDefault();
      event.stopPropagation();

      if (!cart || !cart.items) return;

      var lineNumber = parseInt(
        actionButton.getAttribute("data-vibes-line"),
        10
      );

      var action =
        actionButton.getAttribute("data-vibes-action");

      var item = cart.items[lineNumber - 1];

      if (!lineNumber || !item) return;

      if (action === "remove") {
        changeLine(lineNumber, 0);
        return;
      }

      if (action === "inc") {
        changeLine(
          lineNumber,
          Math.min(MAX_QTY, item.quantity + 1)
        );
        return;
      }

      if (action === "dec") {
        changeLine(
          lineNumber,
          Math.max(0, item.quantity - 1)
        );
      }
    }
  });

  /* Escape closes */
  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;

    var root = getRoot();

    if (
      root &&
      root.getAttribute("aria-hidden") === "false"
    ) {
      closeCart();
    }
  });

  /* =========================================================
     INITIALIZE
  ========================================================= */

  function init() {
    var root = getRoot();
    var panel = getPanel();
    var overlay = getOverlay();

    if (!root) return;

    /* Force known closed state on every page load */
    root.classList.add("pointer-events-none");
    root.setAttribute("aria-hidden", "true");
    root.style.pointerEvents = "none";

    if (panel) {
      panel.style.transform = "translateX(100%)";
    }

    if (overlay) {
      overlay.style.opacity = "0";
      overlay.style.pointerEvents = "none";
    }

    refreshCart().catch(function (error) {
      console.error(
        "[vibes-cart] initial cart fetch failed",
        error
      );
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  /* Shopify theme editor reload support */
  document.addEventListener("shopify:section:load", function () {
    refreshCart().catch(function () {});
  });
})();